import React, { FC, useRef } from "react";
import type { HomeRealTimeTransactionsProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const HomeRealTimeTransactions: FC<HomeRealTimeTransactionsProps> = ({
  content,
  image,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  const refImg = useRef(null);
  const isInViewImg = useInView(refImg, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="homeRealTimeTransactions">
      <div className="wrapper" ref={ref}>
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={content}
              className="homeRealTimeTransactions--content"
              style={{
                transform: isInView ? "none" : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
              }}
            />
          }
          isInView={isInView}
        />
      </div>
      <div className="wrapper wrapper_lg" ref={refImg}>
        {image.file?.url && (
          <Image
            className="homeRealTimeTransactions--image"
            src={image as any}
            alt={image.title}
            options={{
              sizes: {
                exec: [
                  {
                    width: 1440,
                    height: 594,
                  },
                ],
              },
            }}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
